export default "__VITE_ASSET__C4a1KsNz__"